import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './shared/login/login.component';
import { SsoComponent } from './shared/login/sso/sso.component';
import { CallbackSamlComponent } from './shared/callback-saml/callback-saml.component';
import { SamlErrorComponent } from './shared/callback-saml/saml-error/saml-error.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'sso',
    component: SsoComponent
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  },
  // ,
  // {
  //   path: '**',
  //   redirectTo: '/'
  // }
  {
    path: 'callbackSaml',
    component: CallbackSamlComponent
  },
  {
    path: 'samlError',
    component: SamlErrorComponent
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
